<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Payment Details

      <employee-profile-payroll-payroll-company-payment-details-dialog-edit
        v-if="(companyEmployee.end_date >= this.$moment().format('YYYY-MM-DD') || !companyEmployee.end_date) && $hasPermissionTo(['update employee payroll'])"
        :company-employee="companyEmployee"
        @updated="$emit('load')"
      />
    </h4> 

    <v-row class="mx-0">
      <v-col
        cols="6"
        class="py-0"
      >
        <span class="font-weight-medium">Payment Mode:</span>
        <span class="pl-3">{{ companyEmployee.payment_mode||'N/A' }}</span> 
      </v-col>

      <v-col
        cols="6"
        class="py-0"
      >
        <span class="font-weight-medium">Bank Code:</span>
        <span class="pl-3">{{ companyEmployee.bank_code||'N/A' }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyPaymentDetailsDialogEdit: () => import('@/components/hris/employee/profile/payroll/payroll-company/payment-details/DialogEdit'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    }, 
  }
</script>
